export const SELECT_GAME = "SELECT_GAME";
export const UNSELECT_GAME = "UNSELECT_GAME";
export const SELECT_ENV = "SELECT_ENV";
